module.exports = __webpack_public_path__ + "static/media/YF84_6.7a7d2f73.jpg";